export const skills = [
  {
    category: "Frontend",
    items: [
      { name: "HTML5", level: 90 },
      { name: "CSS3", level: 85 },
      { name: "Talwind css", level: 70 },
      { name: "JavaScript", level: 80 },
      { name: "React", level: 85 },
      { name: "Python", level: 70 }
    ]
  },
  {
    category: "Backend",
    items: [
      { name: "AWS", level: 50 },
      { name: "Node.js", level: 60 },
      { name: "Express", level: 65 },
      { name: "MongoDB", level: 65 },
      { name: "SQL", level: 75 },
    ]
  },
  {
    category: "Tools",
    items: [
      { name: "Git", level: 80 },
      { name: "Canva", level: 70 },
      { name: "Figma", level: 75}
    ]
  }
];